import getHoldPosition from '../../util/title-actions/getHoldPosition';
import HoldInformationTemplate from './HoldInformationV2.html';
import WaitTimeHelper from '../../util/waitTime';
const { text } = window;

export default class HoldInformationV2 extends Backbone.View {
    constructor({ hideHoldsLink = false, isVisitor = false }) {
        super(...arguments);
        this.el = this.el || document.createElement('div');
        this.hideHoldsLink = hideHoldsLink;
        this.isVisitor = isVisitor;
        this.listenTo(this.model, 'change:titleState', this.removeWaitTime);
        this.waitTimeHelper = new WaitTimeHelper({
            model: this.model,
            isVisitor: this.isVisitor,
        });
    }

    render() {
        const view = HoldInformationTemplate({
            description: this.description,
            details: this.details,
            note: this.note,
        });
        this.$el.empty().append(view);

        return this;
    }

    removeWaitTime() {
        if (this.waitTimeHelper.hideWaitTime()) {
            this.$el.hide();
        }
    }

    get description() {
        if (this.model.isExpired) {
            let theText = '';
            if (this.model.get('titleState') === 'onHold') {
                theText = text('holdsRatioHelpModal.noCopiesOnPlaceHold');
            } else {
                theText = text('holdsRatioHelpModal.noCopiesText');
            }
            return this.hideHoldsLink
                ? theText
                : `<span>${theText}<a class="manageHoldsLink" href="/account/holds">${text(
                      'holdSuccessModal.manageHolds'
                  )}</a></span>`;
        } else if (
            this.model.allCopiesAreLuckyDay &&
            this.model.get('titleState') === 'onHold'
        ) {
            let detailsUrl = window.url(window.routes.mediaId, {
                id: this.model.get('id'),
            });
            let detailsLink = `<a style="text-decoration: underline" href="${detailsUrl}">${text(
                'luckyDay.allLuckyDayHoldsInfoLinkText'
            )}</a>`;
            return text('luckyDay.allLuckyDayHoldsInfo', { link: detailsLink });
        } else if (this.model.get('isFastlane')) {
            return text('expectedWaitTime.advantageCaveat');
        } else if (this.isVisitor) {
            return text('expectedWaitTime.rlaCaveat');
        }
        return '';
    }

    get details() {
        let details = [];
        const showWaitTime =
            !this.waitTimeHelper.showWaitTimeUnavailable() &&
            !this.waitTimeHelper.hideWaitTime();
        if (showWaitTime) {
            details.push({
                label: text('expectedWaitTime.waitTime'),
                value: this.waitTimeHelper.waitTimeText(),
            });
        }

        if (this.model.get('titleState') === 'onHold') {
            const holdListPosition = getHoldPosition(this.model.attributes);

            if (holdListPosition > 0) {
                details.push({
                    label: text('expectedWaitTime.placeInLine'),
                    value: holdListPosition,
                });
            }
        }

        let ownedCopies = this.model.get('ownedCopies') || 0;
        let totalHolds = this.model.get('holdsCount') || 0;
        let displayOwnedCopies = this.model.get('ownedCopies') || 0;
        if (this.model.isPreReleaseSuTitle) {
            displayOwnedCopies = text('itemCountGenericHtml', {
                currentItem: 0,
                totalItems: '<span class="larger-infinity">∞</span>',
            });
        }

        details.push({
            label: text('expectedWaitTime.libraryCopies'),
            value: displayOwnedCopies,
        });

        if (ownedCopies > 1) {
            let holdsRatio =
                ownedCopies && totalHolds ? totalHolds / ownedCopies : 0;
            let ratioDisplayValue =
                holdsRatio > 0 && holdsRatio < 1
                    ? '< 1'
                    : Math.round(holdsRatio);
            details.push({
                label: text('expectedWaitTime.peopleWaitingTotal'),
                value: totalHolds,
            });
            details.push({
                label: text('expectedWaitTime.peopleWaitingPerCopy'),
                value: ratioDisplayValue,
            });
        } else {
            details.push({
                label: text('expectedWaitTime.peopleWaiting'),
                value: totalHolds,
            });
        }
        return details;
    }

    get note() {
        return [];
    }
}
